import { ComponentProps, useCallback, useState } from "react";
import { MDXProvider } from "@mdx-js/react";

import { Button, Checkbox, Flex, Typography } from "@payping/web-components";

import useTranslator from "@/shared/translate/translator";
import ContractContent from "@/refund/components/contract-content/contract-content.component.mdx";

type CheckboxProps = ComponentProps<typeof Checkbox>;
type Props = { onConfirm: () => void; loading: boolean };

const Contract: React.FC<Props> = ({ onConfirm, loading }) => {
  const { t } = useTranslator("refund.contract");

  const [checked, setChecked] = useState(false);
  const handleChangeCheckbox = useCallback(
    ((e) => {
      setChecked(e.target.checked);
    }) as NonNullable<CheckboxProps["onChange"]>,
    [setChecked],
  );

  return (
    <Flex vertical justify="flex-start" align="flex-start">
      <Typography.Title level={5} className="!tw-mb-[32px]">
        {t("title2")}
      </Typography.Title>
      <Flex vertical justify="flex-start" align="flex-start" className="tw-mb-[16px] tw-max-h-[70vh] tw-overflow-auto">
        <MDXProvider>
          <ContractContent />
        </MDXProvider>
      </Flex>
      <Checkbox className="!tw-mb-[32px]" checked={checked} onChange={handleChangeCheckbox}>
        {t("checkbox")}
      </Checkbox>
      <Button type="primary" disabled={!checked} onClick={onConfirm} loading={loading}>
        {t("action")}
      </Button>
    </Flex>
  );
};
export default Contract;
